import { render } from "./ButtonDetails.vue?vue&type=template&id=b502f73a&ts=true&lang=pug"
import script from "./ButtonDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonDetails.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__